<template>
  <section>
    <ResourcesHeader />
    <ResourcesIntro />
    <ResourcesIndex />
    <ResourcesMore />
    <NavigationCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Resources',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['resources-index'] || {}
    }
  }
}
</script>
